// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1505":"12089fa5","3352":"9616c28f","5457":"8c67a228","7398":"9616c28f","8884":"676d2b44","9135":"151d0a7f"}[chunkId] + ".chunk.css";
};